import '../lib/owl.carousel2';

export default class {

    constructor() {

        const self = this;
        let previousWidth = $(window).width();
        const breakpoint = 1026;

        const navText = $('.videocarousel').hasClass('transback')
            ? [
                '<button class="button-as-link" aria-label="Previous slide"><img src="/assets/img/left-arrow-white.svg" alt="" /></button>',
                '<button class="button-as-link" aria-label="Next slide"><img src="/assets/img/right-arrow-white.svg" alt="" /></button>'
            ]
            : [
                '<button class="button-as-link" aria-label="Previous slide"><img src="/assets/img/left-arrow-blue.svg" alt="" /></button>',
                '<button class="button-as-link" aria-label="Next slide"><img src="/assets/img/right-arrow-blue.svg" alt="" /></button>'
            ];

        $('.videocarousel-slides').owlCarousel({
            items: 1,
            center: true,
            autoWidth: true,
            loop: true,
            margin: 93,
            dots: false,
            nav: true,
            navText: navText
        });

        $('.videocarousel-slides-mobile').owlCarousel({
            items: 1,
            dots: true,
            nav: false
        });

        $('.videocarousel-slides, .videocarousel-slides-mobile').on('translated.owl.carousel', function(event) {
            const $container = $(event.target);
            self.updateSlideFocus($container);
        });

        $('.videocarousel-slides, .videocarousel-slides-mobile').each(function() {
            const $container = $(this);
            setTimeout(() => self.updateSlideFocus($container), 50);
        });

        $('.videocarousel-slides-mobile .owl-dot').attr('tabindex', '0').attr('role', 'button').each(function(index) {
            $(this).attr('aria-label', 'Go to slide ' + (index + 1));
        }).on('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                $(this).trigger('click');
                e.preventDefault();
            }
        });

        $('.videocarousel-slide-playbutton').on('click', function() {
            self.stopVideos();
            const videoLink = $(this).data('link');
            const videoTitle = $(this).data('screenreadertitle');
            const html = `<iframe title="${videoTitle}" class="videocarousel-slide-video" frameborder="0" allow="autoplay; fullscreen" src="${videoLink}"></iframe>`;
            $(this).after(html);
            $(this).hide();
        });

        $(window).on('resize', function() {
            const newWidth = $(window).width();
            if ((newWidth >= breakpoint && previousWidth < breakpoint) || (newWidth < breakpoint && previousWidth >= breakpoint)) {
                self.stopVideos();
            }
            previousWidth = newWidth;
        });
    }

    stopVideos() {
        $('.videocarousel-slide-video').each(function() {
            $(this).prev().show();
            $(this).remove();
        });
    }

    updateSlideFocus(container) {
        if (!container || container.length === 0)
            return;

        const $items = container.find('.owl-item');
        if ($items.length === 0) 
            return;

        $items.each(function() {
            const $item = $(this);
            $item.attr('aria-hidden', 'true');
            $item.find('button, a, input, [tabindex]').attr('tabindex', '-1');
        });

        $items.each(function() {
            const $item = $(this);
            const isDesktop = $item.closest('.videocarousel-slides').length > 0;
            const isMobile = $item.closest('.videocarousel-slides-mobile').length > 0;

            const shouldEnable =
                (isDesktop && $item.hasClass('center')) ||
                (isMobile && $item.hasClass('active'));

            if (shouldEnable) {
                $item.attr('aria-hidden', 'false');
                $item.find('button, a, input, [tabindex]').attr('tabindex', '0');
                return false; 
            }
        });
    }

}